import { Github } from '@styled-icons/entypo-social/Github'

import { Twitter } from '@styled-icons/entypo-social/Twitter'
import { Facebook } from '@styled-icons/entypo-social/Facebook'


const Icons = {
    Github, Twitter, Facebook 
}

export default Icons
